import React, { useContext, Fragment } from "react";
import { RequisitionsListPatientInfoTable } from "./RequisitionsListPatientInfoTable";
import { NumberField, TextField, DateField } from "../TableFilter";
import { TableContext } from "./RequisitionsListTable";

export const RequisitionsListTableBody = ({ id, careType, ...props }) => {
  const { getTableBodyProps, rows, prepareRow, visibleColumns } =
    useContext(TableContext);

  return (
    <tbody {...getTableBodyProps()}>
      <tr role="row">
        <TextField
          onChange={props.handleFilterChange}
          onSubmit={props.onSubmit}
          filter={props.filter}
          field="patient__external_id"
        />
        <TextField
          onChange={props.handleFilterChange}
          onSubmit={props.onSubmit}
          filter={props.filter}
          field="patient__name"
        />
        <TextField
          onChange={props.handleFilterChange}
          onSubmit={props.onSubmit}
          filter={props.filter}
          field="patient__birth_number"
        />
        <NumberField
          onChange={props.handleFilterChange}
          onSubmit={props.onSubmit}
          filter={props.filter}
          field="patient__age"
        />
        <TextField
          onChange={props.handleFilterChange}
          onSubmit={props.onSubmit}
          filter={props.filter}
          field="care__main_diagnosis__name"
        />
        <TextField
          onChange={props.handleFilterChange}
          onSubmit={props.onSubmit}
          filter={props.filter}
          field="care__clinic__description"
        />
        <TextField
          onChange={props.handleFilterChange}
          onSubmit={props.onSubmit}
          filter={props.filter}
          field="care_actual_department_description"
        />
        {careType === "hospitalization" && (
          <NumberField
            onChange={props.handleFilterChange}
            onSubmit={props.onSubmit}
            filter={props.filter}
            field="care_days_count"
          />
        )}
        {careType === "ambulation" && (
          <DateField
            onChange={props.handleDateChange}
            onSubmit={props.onSubmit}
            filter={props.filter}
            field="care__started_at"
          />
        )}
        {careType === "hospitalization" && (
          <DateField
            onChange={props.handleDateChange}
            onSubmit={props.onSubmit}
            filter={props.filter}
            field="care_last_dekurz_date"
          />
        )}

        {careType === "ambulation" && (
          <TextField
            onChange={props.handleFilterChange}
            onSubmit={props.onSubmit}
            filter={props.filter}
            field="applicant__name"
          />
        )}

        {careType === "hospitalization" && (
          <TextField
            onChange={props.handleFilterChange}
            onSubmit={props.onSubmit}
            filter={props.filter}
            field="care_doctor_name"
          />
        )}

        {careType === "ambulation" && (
          <TextField
            onChange={props.handleFilterChange}
            onSubmit={props.onSubmit}
            filter={props.filter}
            field="care__category__name"
          />
        )}

        <td>
          <button
            style={{ width: 116 }}
            className="button"
            onClick={() => props.onSubmit()}
          >
            Filtrovat
          </button>
          <button
            style={{ width: 122 }}
            className="button"
            onClick={props.handleResetFilter}
          >
            Resetovat filtr
          </button>
        </td>
      </tr>
      {rows.map((row) => {
        prepareRow(row);
        return (
          <Fragment key={row.index}>
            <tr {...row.getRowProps(row)}>
              {row.cells.map((cell) => {
                return <td {...cell.getCellProps()}>{cell.render("Cell")}</td>;
              })}
            </tr>
            {row.isExpanded ? (
              <tr role="row">
                <td
                  colSpan={visibleColumns.length}
                  style={{ flexDirection: "column" }}
                >
                  <div style={{ width: "80%" }}>
                    <RequisitionsListPatientInfoTable
                      id={row.original.id}
                      row={row}
                      careType={careType}
                    />
                  </div>
                </td>
              </tr>
            ) : null}
          </Fragment>
        );
      })}
    </tbody>
  );
};
